export default __webpack_public_path__ + "static/media/unequal-sa2.1db895c5.jpg";